import { Node, mergeAttributes } from "@tiptap/core";

export const BackgroundColor = Node.create({
	name: "backgroundColor",

	group: "block",

	content: "block+",

	addOptions() {
		return {
			HTMLAttributes: {}
		};
	},

	parseHTML() {
		return [
			{
				tag: "div",
				getAttrs: element => element.style.backgroundColor && null
			}
		];
	},

	renderHTML({ HTMLAttributes }) {
		return ["div", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
	},

	addAttributes() {
		return {
			backgroundColor: {
				default: null,
				parseHTML: element => element.style.backgroundColor,
				renderHTML: attributes => {
					if (!attributes.backgroundColor) {
						return {};
					}
					return {
						style: `background-color: ${attributes.backgroundColor}`
					};
				}
			}
		};
	},

	addCommands() {
		return {
			setBackgroundColor:
				color =>
				({ commands }) => {
					return commands.updateAttributes("backgroundColor", { backgroundColor: color });
				}
		};
	}
});
